import React from 'react';

export const FormBox = ({ children }: { children: React.ReactNode }) => {
  return <div className="col-span-2 flex w-full flex-col gap-2">{children}</div>;
};
